var map = {
	"./arrow-right.svg": "./public/static/svg/arrow-right.svg",
	"./besom.svg": "./public/static/svg/besom.svg",
	"./defn.svg": "./public/static/svg/defn.svg",
	"./hand.svg": "./public/static/svg/hand.svg",
	"./html.svg": "./public/static/svg/html.svg",
	"./mail.svg": "./public/static/svg/mail.svg",
	"./marker.svg": "./public/static/svg/marker.svg",
	"./phone.svg": "./public/static/svg/phone.svg",
	"./time.svg": "./public/static/svg/time.svg",
	"./timer.svg": "./public/static/svg/timer.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/static/svg sync recursive \\.svg$";